module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_6000.75f7f5f8.png";